import styled, { css } from 'styled-components';
import ReactSelect from 'react-select';

import { colors, radius } from '../../styles/tokens';

// Altura padrão dos inputs do sistema (ver SearchField) -- centralizada
// aqui pra `index.tsx` (que monta o `control.minHeight` do react-select
// via objeto JS, não CSS) usar a mesma constante em vez de repetir o
// número solto.
export const CONTROL_HEIGHT = 42;

interface ContainerProps {
  isFocused?: boolean;
  isFilled?: boolean;
  isErrored?: boolean;
  isFlex1Mobile?: boolean;
}

export const ContainerInput = styled.div<ContainerProps>`
  display: flex;

  flex-direction: column;
  padding: 0;
  transition: border-color 0.2s;

  span {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurfaceVariant};
    margin-left: 4px;
    line-height: 20px;
  }

  @media (max-width: 1199px) {
    ${props =>
      !props.isFlex1Mobile &&
      css`
        width: 100%;
      `}
  }
`;

export const SelectComponent = styled(ReactSelect)<ContainerProps>`
  width: 100%;
  border-radius: ${radius.DEFAULT};

  padding: 0;
  background-color: transparent;
  outline: none;

  color: ${colors.onSurface};

  font-size: 16px;
  font-weight: 400;

  border: 1px solid ${colors.outlineVariant};

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  ${props =>
    props.isFilled &&
    css`
      border-color: ${colors.primary};
    `}
`;

export const ContainerError = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;

  span {
    color: ${colors.error};
    font-size: 13px;
    margin-left: 0;
  }
`;
